import React from 'react';

import { useTranslation } from 'react-i18next';

import { AddNewAlbum } from '@features/AlbumSelect/ui/AddNewAlbum';
import { Icon, MultiSelect } from '@shared/ui';
import { OptionType } from '@shared/ui/MultiSelect';

interface AlbumSelectProps {
    selected: OptionType[];
    options: OptionType[];
    deleteHandle: (value: string) => void;
    onChange: (value: string) => void;
    onAddNewTag: (value: OptionType) => void;
    title?: string;
}

export const AlbumSelect = ({
    selected,
    options,
    deleteHandle,
    onChange,
    onAddNewTag,
    title,
}: AlbumSelectProps) => {
    const { t } = useTranslation();

    return (
        <MultiSelect
            isSmartPosition
            title={title}
            selected={selected}
            options={options}
            placeholder={t('AlbumSelect.return.MultiSelect.placeholder')}
            deleteHandle={deleteHandle}
            onChange={onChange}
            leftIcon={<Icon iconName="taskTags" />}
            onAddNewTag={onAddNewTag}
            showCheckboxes
            emptySearchTitle={t('AlbumSelect.return.MultiSelect.emptySearchTitle')}
            renderAddOption={(value, addNewTag) => (
                <AddNewAlbum addNewTag={addNewTag} value={value} />
            )}
        />
    );
};
